"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VERIFICATION_RESULT_TASK_LIST_ITEM_KEY = exports.VERIFICATION_REQUEST_TASK_LIST_ITEM_KEY = void 0;
exports.VERIFICATION_REQUEST_TASK_LIST_ITEM_KEY = 'verificationRequest';
exports.VERIFICATION_RESULT_TASK_LIST_ITEM_KEY = 'verificationResult';
